import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { brandStorageKey } from "@core/constants";
import { BasicBrand } from "@core/entities";
import { StorageMap } from "@ngx-pwa/local-storage";
import { Observable } from "rxjs";
import { map, tap } from "rxjs/operators";

/**
 * Solo exige que el brand tenga zappie habilitado. Los permisos de cada tab de Propio los resuelve
 * ZappieTabGuard; también protege "Ingresos y costos" de Settlement, que no depende de ellos.
 */
@Injectable()
export class ZappieAccessGuard implements CanActivate {
  constructor(private router: Router, private storage: StorageMap) {}

  canActivate(): Observable<boolean> {
    return (this.storage.get(brandStorageKey) as Observable<BasicBrand>).pipe(
      map(brand => !!brand?.enable_zappie_functions),
      tap(hasAccess => {
        if (!hasAccess) {
          this.router.navigate(["/dashboard/orders"]);
        }
      })
    );
  }
}
